import React from 'react';
import {useTheme} from '../../../theme';
import {BaseLayout} from './BaseLayout';
import {LayoutProps} from '../types';
import {mapToBaseProperties} from '../functions';

export const Layout: React.FC<LayoutProps> = ({
  children,
  onPress,
  ...props
}) => {
  const theme = useTheme();
  const baseProps = mapToBaseProperties(theme, props);
  return (
    <BaseLayout {...baseProps} onPress={onPress}>
      {children}
    </BaseLayout>
  );
};
